import React from 'react';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Cell } from 'recharts';

const BarChartWidget = ({ config = {} }) => {
  const title = config.title || 'Bar Chart';
  const showGrid = config.showGrid !== false;
  const showLegend = config.showLegend !== false;
  const barRadius = config.barRadius || 4;
  const colors = config.colors || ['#3B82F6', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6'];
  const orientation = config.orientation || 'vertical';

  const demoData = config.data || [
    { name: 'Jan', organic: 4200, paid: 2400, social: 1800 },
    { name: 'Feb', organic: 3800, paid: 2800, social: 2100 },
    { name: 'Mar', organic: 5100, paid: 3200, social: 2400 },
    { name: 'Apr', organic: 4600, paid: 2900, social: 1900 },
    { name: 'May', organic: 5400, paid: 3500, social: 2800 },
    { name: 'Jun', organic: 6200, paid: 3800, social: 3100 }
  ];

  const metrics = config.metrics || Object.keys(demoData[0]).filter(k => k !== 'name');

  return (
    <div className="h-full flex flex-col bg-white p-3">
      <h3 className="text-sm font-semibold text-gray-700 mb-2" style={{ color: config.titleColor || '#374151' }}>
        {title}
      </h3>
      <div className="flex-1 min-h-0">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={demoData} layout={orientation === 'horizontal' ? 'vertical' : 'horizontal'}>
            {showGrid && <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />}
            {orientation === 'horizontal' ? (
              <>
                <XAxis type="number" tick={{ fontSize: 11 }} />
                <YAxis dataKey="name" type="category" tick={{ fontSize: 11 }} width={60} />
              </>
            ) : (
              <>
                <XAxis dataKey="name" tick={{ fontSize: 11 }} />
                <YAxis tick={{ fontSize: 11 }} />
              </>
            )}
            <Tooltip contentStyle={{ fontSize: 12, borderRadius: 8 }} />
            {showLegend && <Legend wrapperStyle={{ fontSize: 11 }} />}
            {metrics.map((metric, idx) => (
              <Bar
                key={metric}
                dataKey={metric}
                fill={colors[idx % colors.length]}
                radius={[barRadius, barRadius, 0, 0]}
                name={metric.charAt(0).toUpperCase() + metric.slice(1)}
              />
            ))}
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default BarChartWidget;
